import * as React from "react";
const SvgRibbon = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 1062 97", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1062 0H531H0L34.8772 48.4999L0 97H531H1062L1027.12 48.4999L1062 0Z", fill: "currentColor" }));
export default SvgRibbon;
